import { MUTATION_TYPES } from './types';
import { initialState } from './state'; //Import initial state object for reset when was destroy

export const mutations = {
  // Keep Reactivity and clear information when is destroyed
  [MUTATION_TYPES.RESET](state) {
    const _state = initialState();
    Object.keys(_state).forEach((key) => {
      state[key] = _state[key];
    });
  },
  [MUTATION_TYPES.SET_REQUESTS](state, results) {
    state.results = results.data;
    state.paging = {
      count: results.count,
      currentPage: results.currentPage,
      pageCount: results.pageCount,
      totalItemCount: results.totalItemCount,
    };
  },
  [MUTATION_TYPES.SET_CURRENT_FILTERS](state, selectedFilter) {
    state.model = selectedFilter;
  },
  [MUTATION_TYPES.SET_FILTERS](
    state,
    { academicYears, services, disciplines, statuses }
  ) {
    //Valid if not undefined (Advanced or Basic mode)
    if (academicYears != undefined) {
      state.filters.academicYears = academicYears;
    }
    if (services != undefined) {
      state.filters.services = services;
      state.filters.disciplines = disciplines;
      state.filters.statuses = statuses;
    }
  },
  [MUTATION_TYPES.SET_CENTERS](state, centers) {
    state.filters.regions = [];
    state.filters.municipalities = [];
    state.filters.schools = [];
    state.filters.centers = centers;
  },
  [MUTATION_TYPES.SET_REGIONS](state, regions) {
    state.filters.municipalities = [];
    state.filters.schools = [];
    state.filters.regions = regions;
  },
  [MUTATION_TYPES.SET_MUNICIPALITIES](state, municipalities) {
    state.filters.schools = [];
    state.filters.municipalities = municipalities;
  },
  [MUTATION_TYPES.SET_SCHOOLS](state, schools) {
    state.filters.schools = schools;
  },
  setFiltersFromProvisionalRemedyRequest(
    state,
    newFiltersFromProvisionalRemedyRequest
  ) {
    state.FiltersFromProvisionalRemedyRequest = newFiltersFromProvisionalRemedyRequest;
  },
};
